import {getUrlParams} from "@/utils/tool"

;(function() {
  function isMiniProgram(fn) {
    let isMiniprogram = window.__wxjs_environment === 'miniprogram'
    fn && fn(isMiniprogram)
    return isMiniprogram
  }
  // 加载js
  function addJs() {
    isMiniProgram(function(res) {
      if (res) {
        // 缓存小程序token和经纬度
        var token = getUrlParams(window.location.href)['miniappToken']

        if (token) {
          localStorage.setItem('miniappToken', token)
        }
        return
      }
    })
  }
  addJs()
})()
